import { render, staticRenderFns } from "./ServiceRequestSimpleAgreementController.vue?vue&type=template&id=5bac8dc6&scoped=true"
import script from "./ServiceRequestSimpleAgreementController.vue?vue&type=script&lang=js"
export * from "./ServiceRequestSimpleAgreementController.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestSimpleAgreementController.vue?vue&type=style&index=0&id=5bac8dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac8dc6",
  null
  
)

export default component.exports